import axios from 'axios';

export default (id, payload) => {
  const promise = new Promise((resolve, reject) => {
    axios.patch(process.env.VUE_APP_API_ADMIN_LOCATION + `providers/${id}`, payload).then(
      ({ data }) => {
        let profile = {};
        if (data.data) {
          profile = data.data;
        }
        resolve(profile);
      },
      (error) => {
        console.log(error);
        reject(error);
      }
    );
  });

  return promise;
};
